import React, { Fragment } from 'react';
import cx from 'classnames';
import T from 'prop-types';

import ArrowChange from '../../../../components/ArrowChange';

const captures = {
  top: 'Top',
  bottom: 'Bottom',
};

const prepareBarData = (percentage) => {
  let position = 'bottom';
  let barPercentage = percentage;

  if (percentage < 50) {
    position = 'bottom';
  } else if (percentage >= 50) {
    position = 'top';
    barPercentage = 100 - percentage < 1 ? 1 : 100 - percentage;
  }

  return {
    capture: captures[position],
    percentage: Math.round(barPercentage, 2),
    className: position,
  };
};

const BarWithTick = ({ percentage, change }) => {
  const barData = prepareBarData(percentage);

  return (
    <div className={cx('tick-bar__box', barData.className)}>
      <div className="tick-bar__progress">
        <div
          className="tick-bar__progress-arrow hicon-rounded-triangle"
          style={{ left: `${percentage}%` }}
        />
      </div>
      <div className="tick-bar__progress-bar" />
      <span className="tick-bar__text">
        {percentage === 0 ? (
          'Unranked'
        ) : (
          <Fragment>
            <span className="capture">{barData.capture}</span>
            {`${barData.percentage}%`}
            <span className="tick-bar__text-percent">
              <ArrowChange
                change={change}
                units="%"
                upArrowClass=""
                downArrowClass=""
                showMathOperators
                precision={1}
                iconPosition="behind"
                className="tick-change"
                showBrackets
              />
            </span>
          </Fragment>
        )}
      </span>
    </div>
  );
};

BarWithTick.propTypes = {
  percentage: T.oneOfType([T.string, T.number]).isRequired,
  change: T.oneOfType([T.string, T.number]).isRequired,
};

export default BarWithTick;
